<template>
    <div class="h-full relative">
        <img
            class="loading absolute"
            src="https://abroad-sin-static.shengqugames-corp.com/wpay/icon_loading.png"
            alt="loading"
        />
    </div>
</template>

<script>
/* eslint-disable camelcase */
import Vue from 'vue';
import { Toast } from 'vant';
import Cookies from 'js-cookie';
import Logs from '@/lib/logs';
import { getWebTicket } from '@/api/login';
import { queryConcat } from '@/lib/utils';
import get from 'lodash/get';

Vue.use(Toast);

export default {
    data() {
        return {
            returnUrl: '/',
            logs: { web_pageid: 'ghome-web-ticket' },
        };
    },
    created() {
        const { return_url = '', appId } = this.$route.query;
        if (return_url && appId) {
            Logs.imgLog_PageLoad(this.logs);
            this.returnUrl = decodeURIComponent(return_url);
            getWebTicket(return_url)
                .then(({ ticket }) => {
                    Logs.imgLog_Button({
                        ...this.logs,
                        web_buttonid: 'get-ticket',
                        web_userid: `cookie=${Cookies.get('WEB_TOKEN')}`,
                    });

                    this.toReturnUrl({ ticket });
                })
                .catch(err => {
                    const error = get(err, 'data.msg', 'get ticket failed');
                    const errorCode = get(err, 'data.code', 500);
                    this.toReturnUrl({ error: encodeURIComponent(error), errorCode });
                });
        } else {
            this.$toast('No return_url or appId parameter');
            setTimeout(() => {
                window.location.href = return_url || '/';
            }, 800);
        }
    },
    methods: {
        toReturnUrl(query) {
            const parameters = queryConcat(query, /\?/.test(this.returnUrl) ? '&' : '?', false);
            window.location.href = this.returnUrl + parameters;
        },
    },
};
</script>

<style scoped>
.loading {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
